module.exports = __webpack_public_path__ + "static/media/cf_rtl_20.be60a149.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/wse-quiz-component/lib/images/cf_rtl_20.png
// module id = 818
// module chunks = 0